"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "VersionStatus", {
    enumerable: true,
    get: function() {
        return VersionStatus;
    }
});
const VersionStatus = {
    Draft: 'draft',
    Published: 'published',
    Duplicating: 'duplicating',
    Failed: 'failed'
};

//# sourceMappingURL=version-status.js.map